import getLocaleHomePage from './get-locale-home-page';

export default {
  getLocaleHomePage,
};
